import {
  defaultExperimentPagesConfig,
  defaultExperimentUtmMediumConfig,
  experimentPagesConfig,
  experimentUtmMediumConfig,
} from 'constants/experiments';
import type { APP_PAGES_NAMES } from 'constants/routes';

/** В зависимости от страницы и значения метки utm_medium, возвращает конфигурацию экспериментов (0 для неактивных) */
export const getUtmAndPageExperiments = <T extends Record<string, string>>(
  experiments: T,
  page: ValuesOf<typeof APP_PAGES_NAMES>,
  utmMediumValue = '',
) => {
  const result = {} as T;
  return Object.entries(experiments).reduce((acc, [name, value]) => {
    const pagesConfig = {
      ...defaultExperimentPagesConfig,
      ...experimentPagesConfig[name as keyof typeof experimentPagesConfig],
    };

    const utmMediumConfig = {
      ...defaultExperimentUtmMediumConfig,
      ...experimentUtmMediumConfig[name as keyof typeof experimentUtmMediumConfig],
    };

    const isAvailableOnPage =
      (pagesConfig.included || []).includes(page) ||
      (!(pagesConfig.excluded || []).includes(page) && !(pagesConfig.included || []).length);

    const isAvailableByUtmMedium =
      (utmMediumConfig.included || []).includes(utmMediumValue) ||
      (!(utmMediumConfig.excluded || []).includes(utmMediumValue) && !(utmMediumConfig.included || []).length);

    return Object.assign(acc, {
      [name]: isAvailableOnPage && isAvailableByUtmMedium ? value : '0',
    });
  }, result);
};
